import React from 'react'

const index = () => {
  return (
    <div>
      <h1>ini halamam mie goreng</h1>
    </div>
  )
}

export default index
